// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2khM9","content":"styles_content__7_Yy4","checkbox":"styles_checkbox__1ZDDr","checkboxLabel":"styles_checkboxLabel__3yEa7"};